import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { useDirection } from "./auth-service-tools250.js";
import { getArrowPositionStyles } from "./auth-service-tools370.js";
const FloatingArrow = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    position,
    arrowSize,
    arrowOffset,
    arrowRadius,
    arrowPosition,
    visible,
    arrowX,
    arrowY,
    style,
    ...others
  } = _ref;
  const {
    dir
  } = useDirection();

  if (!visible) {
    return null;
  }

  return /* @__PURE__ */jsxRuntimeExports.jsx("div", { ...others,
    ref,
    style: { ...style,
      ...getArrowPositionStyles({
        position,
        arrowSize,
        arrowOffset,
        arrowRadius,
        arrowPosition,
        dir,
        arrowX,
        arrowY
      })
    }
  });
});
FloatingArrow.displayName = "@mantine/core/FloatingArrow";
export { FloatingArrow };